module.exports = __webpack_public_path__ + "img/animation.557336d4.gif";